import i18n from 'src/i18n'

import { CoreRouter } from 'src/app/core/routes'

import ErrorBoundary from './error-boundary'
import { Providers } from './providers'

const App = (): JSX.Element => (
  <ErrorBoundary displayMessage={i18n.t('errors.unexpected')}>
    <Providers>
      <CoreRouter />
    </Providers>
  </ErrorBoundary>
)

export default App
